
import React from 'react'
import { Button } from 'antd';

class ViewSignup extends React.Component {

    state = {
        visible: false
    }

    showModal = () => {

        this.setState({ visible: true })

    };

    handleCancel = (e) => {
        this.setState({ visible: false })
    };

    render() {
        return (
            <div id="signup" className='block worksBlock'>
                <div className="container-fluid">
                    <div className="titleHolder">
                        <h2>線上報名</h2>
                        <span>南應大入口/應用系統/「TUT虛擬數位形象大使」徵稿報名系統</span><br />
                        <span>111年09月26日10時-10月10日24時止</span>
                    </div>
                    <div className="contentHolder">
                        <a href="https://portal.tut.edu.tw/" target="_blank" rel="noreferrer">
                            <Button type="primary" onClick={this.showModal} >
                                <i className="fa fa-hand-pointer"></i>
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default ViewSignup